<template>
  <base-dialog
    :title="t('global.leave_site.title')"
    :cancel-text="t('global.cancel')"
    :action-text="t('global.leave_site.yes')"
    data-cy="dialog_leave_page"
    persistent
    max-width="480"
    @action="onAction('leave')"
    @close="onAction('stay')"
  >
    {{ t('global.leave_site.text') }}
  </base-dialog>
</template>

<script lang="ts" setup>
import BaseDialog from '@/components/dialogs/BaseDialog.vue'

const { t } = useI18n()

const emit = defineEmits<{
  (event: 'action', contextData): void
}>()

const onAction = (reason: 'stay' | 'leave') => {
  emit('action', { type: reason })
}
</script>

<style lang="sass"></style>
